<template>
  <div>
    <h1>{{ t("ecommerce.store.displayTitle") }}</h1>
  </div>
</template>

<script>
export default {
  layout: "default",
  data: function () {
    return {};
  },
  meta: "ecommerce.store.pageTitle",
  mounted() {

  }
};
</script>

<style scoped lang="scss"></style>
